import {Checkbox, ListItem, ListItemText, Box} from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import React from 'react';
import {localized} from '../../../../state/i18n/i18n';
import {ReactComponent as DeviceIcon} from '../../../../assets/enhed_01.svg';
import {ReactComponent as SelectedDeviceIcon} from '../../../../assets/selectedDevice.svg';
import './device-menu-item.scss';
import {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {AppState} from '../../../../state/store';
import {showSuccess} from '../../../../state/snackbar/operations';
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';

interface PropsFromParent {
  identifier: any;
  selected?: boolean;
  active?: boolean;
  checkBoxColor: string;
  name?: string;
  calibrationFactor?: number;
  onMenuItemClicked: (identifier: string) => void;
}

interface State {
  calibrationFactor?: number;
}

const mapStateToProps = (state: AppState) => {
  return {
    successStatus: state.devicesReducer.success,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getSnackbarSuccess: () => showSuccess(localized('YourChangesAreSaved'))(dispatch),
});

type Props = Partial<ReturnType<typeof mapDispatchToProps>> &
  Partial<ReturnType<typeof mapStateToProps>> &
  PropsFromParent;

class DeviceMenuItem extends React.PureComponent<Props, State> {
  private checkBoxColor: any;

  constructor(props: Props) {
    super(props);

    this.checkBoxColor = {color: props.checkBoxColor};
    this.state = {calibrationFactor: this.props.calibrationFactor};
  }

  private onIconClicked = () => {
    this.props.onMenuItemClicked(this.props.identifier);
  };

  public render() {
    return (
      <div>
        <div onClick={this.onIconClicked} className="mobile alignItemsCenter deviceDrawerItemContainer lato">
          {this.props.selected ? (
            <SelectedDeviceIcon fill={this.props.checkBoxColor} className="deviceIconChecked" />
          ) : (
            <DeviceIcon fill={this.props.checkBoxColor} className="deviceIcon" />
          )}

          <ListItemText className="deviceName" primary={this.props.name} />
        </div>

        <ListItem className="desktop deviceDrawerItemContainer" alignItems="flex-start" key={this.props.identifier}>
          <Box display="flex" className="deviceMenuWidth">
            <Box className="nameAndDot">
              <Tooltip title={this.props.name!} TransitionComponent={Zoom}>
                <ListItemText className="deviceName lato" primary={this.props.name} />
              </Tooltip>
              <div className="deviceDrawerItem">
                <FiberManualRecordIcon className={'activeDot ' + (this.props.active ? 'active' : 'inActive')} />
                <ListItemText
                  className="lato deviceMenuName multiline"
                  primary={this.props.active ? localized('Active') : localized('InActive')}
                />
              </div>
            </Box>

            <Box className="checkBoxDevices">
              <Checkbox
                onClick={this.onMenuItemClicked}
                style={this.checkBoxColor}
                className="heightOfDeviceCheckbox"
                checked={this.props.selected ? true : false}></Checkbox>
            </Box>
          </Box>
        </ListItem>
      </div>
    );
  }

  private onMenuItemClicked = () => {
    this.props.onMenuItemClicked(this.props.identifier);
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DeviceMenuItem);
